var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinic-payment__tips"},[_c('h3',[_vm._v(" 服务权益 ")]),_c('ul',_vm._l((_vm.tipList),function(tip){return _c('li',{key:tip},[_vm._v(" "+_vm._s(tip)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }